import { Plugin, PluginKey } from 'prosemirror-state';

import { PerformanceType } from '../ExtensionManager/types';

export const nodePerformanceMapKey = new PluginKey('node-performance-map');

export const nodePerformanceMapPlugin = (
  nodePerformanceMap: Map<string, PerformanceType> = new Map(),
) => {
  return new Plugin({
    key: nodePerformanceMapKey,
    state: {
      init() {
        return {
          nodePerformanceMap: nodePerformanceMap,
        };
      },
      apply(tr, old) {
        const props = tr.getMeta(nodePerformanceMapKey);
        return props || old;
      },
    },
  });
};
